import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export interface HighRecentEngagementCampaign {
  campaign_id: string;
  campaign_name: string;
  campaign_type: string;
  total_recent_engagements: number;
  total_recent_engaged_persons: number;
}

/**
 * Hook for fetching campaigns with high recent engagement volumes
 * @param days The number of days to look back (default: 30)
 * @param limit The maximum number of results to return (default: 5)
 */
export function useHighRecentEngagementCampaigns(
  days: number = 30,
  limit: number = 5,
) {
  return useQuery<HighRecentEngagementCampaign[]>({
    queryKey: [
      "datahub",
      "campaigns",
      "high-recent-engagement",
      { days, limit },
    ],
    queryFn: async () => {
      const params = new URLSearchParams({
        days: days.toString(),
        limit: limit.toString(),
      });

      return api.get<HighRecentEngagementCampaign[]>(
        `datahub/campaigns/high-recent-engagement/?${params}`,
      );
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
